module.exports = __webpack_public_path__ + "static/media/YM68_0.dc326cd3.jpg";